export default [
  {
    path: '/tools/:key?',
    name: 'tools',
    component: () => import('@/views/tools/ToolsIndex.vue'),
    meta: {},
  },
];
